module.exports = __webpack_public_path__ + "img/playground.71508c8a.jpg";